import { render, staticRenderFns } from "./ProductMenu.vue?vue&type=template&id=7b618b91&scoped=true"
import script from "./ProductMenu.vue?vue&type=script&lang=js"
export * from "./ProductMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b618b91",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b618b91')) {
      api.createRecord('7b618b91', component.options)
    } else {
      api.reload('7b618b91', component.options)
    }
    module.hot.accept("./ProductMenu.vue?vue&type=template&id=7b618b91&scoped=true", function () {
      api.rerender('7b618b91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stickerMenu/ProductMenu.vue"
export default component.exports